module.exports = __webpack_public_path__ + "static/media/LightsonWonderRock.90fdf44d.jpg";